import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { NOTIFICATIONS } from "constants/action-types";
import { fetchActions, IFetchStoreState, initialBaseState, IResponse, updateActions } from "reducers/base-reducers";
import { Slug } from "constants/notifications";

export interface INotificationsState {
    feeds: IFeedState;
    collections: ICollectionsState;
    feedNotifications: IFeedNotificationsState;
}

interface ICollectionsState {
    userNotification: INotification[];
    userNotificationFetching: boolean;
    userNotificationError: Error | string;
    userNotificationHasNextPage: boolean;
}

export interface IFeedNotification {
    list: INotification[];
    hasNextPage: boolean;
}

export type IFeedNotifications = {
    [slug in Slug]: IFeedNotification;
};

type IFeedNotificationsState = IFetchStoreState<IFeedNotifications>;
type IFeedState = IFetchStoreState<IFeedEntry[]>;

interface IBaseParams {
    start_id_open?: string;
    limit?: number;
    merchant_id?: string;
}

export interface INotificationFilters extends IBaseParams {
    mark_seen?: boolean;
    mark_read?: boolean;
    mark_seen_all?: boolean;
    mark_read_all?: boolean;
    mark_seen_notification_ids?: string[];
    mark_read_notification_ids?: string[];
}

export interface IFeedsFilters extends IBaseParams {
    slugs?: Slug[];
    start_slug_open?: string;
}

export interface INotificationStatusParams {
    seen?: Array<string | number>;
    read?: Array<string | number>;
    readAll?: boolean;
    merchant_id?: string;
}

export interface IExportNotificationStatusParams {
    seen?: number;
    read?: number;
    readAll?: boolean;
    export_id?: string;
}

export interface INotification {
    id: string;
    body: string;
    body_markdown?: string;
    title: string;
    subtitle: string;
    is_read: boolean;
    is_seen: boolean;
    created_at: string;
    updated_at: string;
    url: {
        href: string;
        href_lang: string;
        media_type: string;
        name: string;
        type: string;
    };
    logo_url?: {
        href: string;
    };
}

export interface IFeedEntry {
    id: string;
    user_id: string;
    feed_slug_id: Slug;
    unseen: string;
    unread: string;
    item_groups_count: string;
}

export interface IExportNotitications {
    unseen: number;
    unread: number;
    exports: {
        createdOn: number;
        is_read: boolean;
        is_seen: boolean;
        error?: boolean;
        files: string[];
        products: string[];
        id: string;
    }[];
}

export const notifications = combineReducers<INotificationsState>({
    feeds: handleActions<IFeedState>(
        {
            ...fetchActions<IFeedEntry[]>(NOTIFICATIONS.FEEDS.FETCH),
            ...updateActions<IFeedEntry[]>(NOTIFICATIONS.FEEDS),
        } as any,
        initialBaseState
    ),
    feedNotifications: handleActions<IFeedNotificationsState>(
        {
            ...fetchActions<IFeedNotifications>(NOTIFICATIONS.FEED_NOTIFICATIONS.FETCH),
            // prettier-ignore
            [NOTIFICATIONS.FEED_NOTIFICATIONS.FETCH.SUCCESS]: (state: IFeedNotificationsState, { payload, hasNextPage }: IResponse<IFeedNotifications>): IFeedNotificationsState => ({
                ...state,
                payload: { ...state.payload, ...payload },
                hasNextPage,
                error: null,
                isFetching: false,
            }),
            ...updateActions<IFeedNotificationsState>(NOTIFICATIONS.FEED_NOTIFICATIONS),
        } as any,
        initialBaseState
    ),
});
